export const TOKENS = {
  coral: {
    bg: "#FFF7F4",
    bgGrad: "linear-gradient(180deg, #FFEDE5 0%, #FFF7F4 30%)",
    surface: "#FFFFFF",
    surfaceAlt: "#FFF1EC",
    surfaceHi: "#FFE4D9",
    ink: "#1F1418",
    inkSoft: "#5C4A52",
    inkMute: "#9C8A91",
    line: "#F2DACE",
    lineStrong: "#E5C7B6",
    primary: "#FF4F6D",
    primary2: "#FF7A4F",
    primaryGrad: "linear-gradient(135deg, #FF7A4F 0%, #FF4F6D 100%)",
    primarySoft: "#FFE3E8",
    accent: "#7B5BFF",
    accentSoft: "#EDE6FF",
    success: "#1FBF7A",
    successSoft: "#D7F4E5",
    warm: "#FFB347",
    warmSoft: "#FFEFD5",
    gold: "#FFC93C",
    goldGrad: "linear-gradient(135deg, #FFD978 0%, #FFA63C 100%)",
    danger: "#FF4F6D",
    shadow: "0 6px 24px rgba(255,79,109,0.15)",
    shadowSoft: "0 2px 12px rgba(31,20,24,0.06)",
  },
};

export const t = TOKENS.coral;

export const FONT_STACK = "'Plus Jakarta Sans', Inter, system-ui, sans-serif";
